import AgendaPage from '@/components/agenda/agendaPage.vue'
import ConfirmDialog from "@/components/ConfirmDialog.vue";
import AgendaMasterGrid from "@/components/agenda/agendaMasterGrid.vue";
import axios from "axios";
import Loader from "@/components/Loader.vue";
import MessageSheet from "@/components/MessageSheet.vue";
import AuthService from "@/codeFiles/auth/auth.service.js";
import { mapState, mapActions, mapGetters } from "vuex";
import { createUUID } from "../../utils/util";
import MeetingTypeAutocomplete from "@/components/agenda/MeetingTypeAutocomplete.vue";
import SearchInput from "@/components/SearchInput.vue";
import MeetingTypeChipGroup from "@/components/agenda/MeetingTypeChipGroup.vue";
import MeetingTypeMenuList from "@/components/agenda/MeetingTypeMenuList.vue";



export default {
    name: "AgendaMaster",
    components: {
        AgendaPage,
        ConfirmDialog,
        AgendaMasterGrid,
        Loader,
        MessageSheet,
        MeetingTypeAutocomplete,
        SearchInput,
        MeetingTypeChipGroup,
        MeetingTypeMenuList
    },
    data: () => ({
        openMeetingTypeMenu: false,
        dialogAgenda: false,
        displayLoading: false,
        loadingMessage: '',
        displayMessage: false,
        messageType: '',
        message: '',
        valid: false,
        search: '',
        selectedMeetingTypes: [],
        screenHeight: 0,
        /*   meetingTypes: [
              { label: "取締役会", color: "#F5CBA7" },
              { label: "監査等委員会／監査役会", color: "#A2D9CE" },
              { label: "指名委員会", color: "#D2B4DE" },
              { label: "監査役会", color: "#F9E79F" },
              { label: "報酬委員会", color: "#F5B7B1" },
          ], */

        AgendaCategories: [
            { order: 1, name: "Strategy", color: "#B7950B" },
            { order: 2, name: "Governance", color: "#CD6155" },
            { order: 3, name: "HR", color: "#F5B041" },
            { order: 4, name: "Investment", color: "#17A589" },
            { order: 5, name: "Finance", color: "#2471A3" },
            { order: 6, name: "Others", color: "#5D6D7E" },
        ],
        agendaFormData: {
            id: '',
            agendaName: '',
            category: '',
            meetingType: '',
            priority: '',
            frequency: '',
            resolutionType: '',
            topics: [],
            tenantid: sessionStorage.getItem("tenantId"),
            memo: '',
        },
    }),
    async created() {
        this.authService = new AuthService();
        this.user = this.authService.app.getAccount();
        // this.agendaData = this.initializeData();
        //this.filteredAgendaData = this.agendaData;
        //await this.getAgendaList();
    },
    async mounted() {
        // if (!this.agendaListData.length) {
        //     await this.getTenantConfigList();
        //     await this.getMeetingListApi();
        //     await this.getAgendaListApi();
        // }
    },
    computed: {
        selectedTenant(){
            return sessionStorage.getItem("tenantId");
          },
        ...mapState({
            agendaListData: (state) => state.agenda.agendaList,
        }),
        ...gettersMap(),
        agendaData() {
            const data = this.agendaListData.map((item) => {
                const category = this.categoriesList.find((c) => String(c.name).toLowerCase() === String(item.category).toLowerCase())
                    || { order: 0, name: item.category, color: '#2471A3', };
                const meetingType = this.meetingTypesList.find((c) => String(c.label).toLowerCase() === String(item.meetingType).toLowerCase())
                    || { label: item.meetingType, color: '#F5CBA7' }

                return {
                    id: item.id,
                    agendaName: item.agendaName,
                    priority: item.priority,
                    frequency: item.frequency,
                    resolutionType: item.resolutionType,
                    category,
                    meetingType,
                    topics: item.topics,
                    memo: item.memo,
                    tenantid: item.tenantid
                }
            });

            return data
        },
        filteredAgendaData() {
            return this.filterAgendas(this.selectedMeetingTypes);
        },
        meetingTypes() {
            return this.meetingTypesList;
        }

    },
    watch: {
        agendaListData(value) {
            // console.log(JSON.stringify(value))
        }
    },

    methods: {
        ...mapActions({
            getAgendaListApi: "agenda/getAgendaList",
            createAgendaData: "agenda/createAgenda",
            updateAgendaData: "agenda/updateAgenda",
            getTenantConfigList: "tenant/getTenantConfigList",
            getMeetingListApi: "meeting/getMeetingList",
        }),
        openMenu() {
            this.openMeetingTypeMenu = true
        },
        createUUID,
        onSaveAgenda() {
            if (this.agendaFormData.id) {
                this.agendaFormData.category = this.agendaFormData.category.name || ""
                this.agendaFormData.meetingType = this.agendaFormData.meetingType.label || ""
                this.updateAgendaData(this.agendaFormData)
                this.dialogAgenda = false
            } else {
                const guidId = createUUID()
                this.agendaFormData.id = guidId;
                this.agendaFormData.category = this.agendaFormData.category.name || ""
                this.agendaFormData.documents = []
                this.agendaFormData.topics = this.agendaFormData.topics.map(obj => ({ ...obj, agendaId: guidId }))
                this.agendaFormData.meetingType = this.agendaFormData.meetingType.label || ""
                this.createAgendaData(this.agendaFormData)
                this.dialogAgenda = false
            }
        },
        onCloseAgendaDialog() {
            this.dialogAgenda = false
        },
        showMessageSheet(message, messageType) {
            this.displayMessage = true;
            this.message = message;
            this.messageType = messageType;
        },
        async getAgendaList() {
            this.displayLoading = true;
            this.loadingMessage = "Data loading, Please wait...";
            await this.authService.getToken().then((token) => {
                axios(process.env.VUE_APP_AGENDA_SERVICE + "agendalist", {
                    headers: {
                        Authorization: "Bearer " + token.accessToken,
                    },
                    params: {
                        tenant: this.selectedTenant,
                        userId: this.user.userName,
                    },
                })
                    .then((response) => {
                        //this.roles = response.data;
                        this.displayLoading = false;
                        this.agendaData = response.data.map((item) => ({
                            category: this.getCategory(item.category),
                            ...item,
                        }));
                        //this.agendaData = response.data;

                    })
                    .catch((e) => {
                        console.log(e);
                        this.showMessageSheet('Failed to load Agenda List', 'error');
                    });
            });
        },

        getCategory(category) {

            return this.AgendaCategories.find((s) => s.name === category);
        },
        EditAgenda(agenda) {
            this.agendaFormData = Object.assign({}, agenda);
            this.dialogAgenda = true;
        },
        CreateAgenda() {
            this.agendaFormData = {
                id: '',
                agendaName: '',
                category: '',
                meetingType: '',
                priority: '',
                frequency: '',
                resolutionType: '',
                topics: [],
                tenantid: this.selectedTenant,
                memo: '',
            }
            this.dialogAgenda = true;
        },
        onResize() {
            this.screenHeight = window.innerHeight - 140;
        },
        filterAgendas(selectedMeetings) {
            if (selectedMeetings.length === 0) {
                return this.agendaData;
            } else {
                let temp = [];
                selectedMeetings.forEach(element => {
                    let agendas = this.agendaData;
                    temp = temp.concat(agendas.filter(x => x.meetingType.label === element.label))
                });
                return temp;
            }

        },
        initializeData() {
            return [{
                agendaId: 0,
                agendaTitle: "Approval of FY22 Q2 Financial Disclosure",
                category: { order: 5, name: "Finance", color: "#2471A3" },
                meetingType: { label: "取締役会", color: "#F5CBA7" },
                priority: "High",
                frequency: "Annually",
                resolutionType: "In Person",
                topics: [{
                    topicText: "Approval of FY22 Q2 Financial Disclosure",
                    topicCategory: 'A',
                    timeinMins: 15
                }],
                note: "",
            },
            {
                agendaId: 1,
                agendaTitle: "DIVAサクセッションについて",
                category: { order: 3, name: "HR", color: "#F5B041" },
                meetingType: { label: "取締役会", color: "#F5CBA7" },
                priority: "High",
                frequency: "Adhoc",
                resolutionType: "In Person",
                topics: [{
                    topicText: "コンセンサスの形成に向けた議論",
                    topicCategory: 'S',
                    timeinMins: 60,
                },],
                note: "",
            },

            {
                agendaId: 2,
                agendaTitle: "報告事項-0",
                category: { order: 2, name: "Governance", color: "#CD6155" },
                meetingType: { label: "取締役会", color: "#F5CBA7" },
                priority: "Low",
                frequency: "Quarterly",
                resolutionType: "In Person",
                topics: [{
                    topicText: "ID社の状況について",
                    topicCategory: 'R',
                    timeinMins: 10
                },

                ],
                note: "",
            },

            {
                agendaId: 3,
                agendaTitle: "US Fund Management Status Report",
                category: { order: 4, name: "Investment", color: "#17A589" },
                meetingType: { label: "取締役会", color: "#F5CBA7" },
                priority: "Low",
                frequency: "Quarterly",
                resolutionType: "In Person",
                topics: [{
                    topicText: "US Fund Management Status Report",
                    topicCategory: 'R',
                    timeinMins: 0
                },

                ],
                note: "",
            },

            {
                agendaId: 4,
                agendaTitle: "Status Report on Investment Projects-1",
                category: { order: 4, name: "Investment", color: "#17A589" },
                meetingType: { label: "取締役会", color: "#F5CBA7" },
                priority: "Medium",
                frequency: "Quarterly",
                resolutionType: "In Person",
                topics: [{
                    topicText: "AVANT ISU Status Report",
                    topicCategory: 'R',
                    timeinMins: 15
                },

                ],
                note: "",
            },

            {
                agendaId: 14,
                agendaTitle: "Status Report on Investment Projects-2",
                category: { order: 4, name: "Investment", color: "#17A589" },
                meetingType: { label: "取締役会", color: "#F5CBA7" },
                priority: "Medium",
                frequency: "Quarterly",
                resolutionType: "In Person",
                topics: [{
                    topicText: "Metapraxis Japan Business Status Report",
                    topicCategory: 'R',
                    timeinMins: 15
                },

                ],
                note: "",
            },

            {
                agendaId: 15,
                agendaTitle: "Status Report on Investment Projects-3",
                category: { order: 4, name: "Investment", color: "#17A589" },
                meetingType: { label: "取締役会", color: "#F5CBA7" },
                priority: "Medium",
                frequency: "Quarterly",
                resolutionType: "In Person",
                topics: [{
                    topicText: "Metapraxis Company’s Business Status Report (If time permits)",
                    topicCategory: 'R',
                    timeinMins: 0
                },

                ],
                note: "",
            },
            {
                agendaId: 5,
                agendaTitle: "Business Performance and Financial Report",
                category: { order: 5, name: "Finance", color: "#2471A3" },
                meetingType: { label: "取締役会", color: "#F5CBA7" },
                priority: "Medium",
                frequency: "Quarterly",
                resolutionType: "In Writing",
                topics: [{
                    topicText: "Business Performance and Financial Report",
                    topicCategory: 'R',
                    timeinMins: 0
                },],
                note: "",
            },

            {
                agendaId: 6,
                agendaTitle: "マテリアリティ",
                category: { order: 1, name: "Strategy", color: "#B7950B" },
                meetingType: { label: "取締役会", color: "#F5CBA7" },
                priority: "High",
                frequency: "Annually",
                resolutionType: "In Person",
                topics: [{
                    topicText: "マテリアリティの共有",
                    topicCategory: 'A',
                    timeinMins: 15
                },],
                note: "取締役会では共有のみ",
            },
            {
                agendaId: 7,
                agendaTitle: "選定基準（策定・見直し）",
                category: { order: 3, name: "HR", color: "#F5B041" },
                meetingType: { label: "監査役会", color: "#F9E79F" },
                priority: "Low",
                frequency: "Quarterly",
                resolutionType: "In Writing",
                topics: [{
                    topicText: "選定基準（策定・見直し）",
                    topicCategory: 'R',
                    timeinMins: 30
                },],
                note: "",
            },



            {
                agendaId: 9,
                agendaTitle: "戦略的投資案件",
                category: { order: 4, name: "Investment", color: "#17A589" },
                meetingType: { label: "監査等委員会／監査役会", color: "#A2D9CE" },
                priority: "High",
                frequency: "Adhoc",
                resolutionType: "In Person",
                topics: [{
                    topicText: "案件情報共有",
                    topicCategory: 'A',
                    timeinMins: 30
                }, {
                    topicText: "投資回収計画",
                    topicCategory: 'A',
                    timeinMins: 60
                },
                {
                    topicText: "LOI決議",
                    topicCategory: 'R',
                    timeinMins: 30
                },
                {
                    topicText: "デューデリ報告",
                    topicCategory: 'R',
                    timeinMins: 60
                },
                {
                    topicText: "投資実行決議",
                    topicCategory: 'S',
                    timeinMins: 30
                },

                ],
                note: "",
            },


            {
                agendaId: 10,
                agendaTitle: "予算承認",
                category: { order: 5, name: "Finance", color: "#2471A3" },
                meetingType: { label: "監査役会", color: "#F9E79F" },
                priority: "High",
                frequency: "Annually",
                resolutionType: "In Person",
                topics: [{
                    topicText: "TD予算報告",
                    topicCategory: 'A',
                    timeinMins: 60
                },
                {
                    topicText: "主要事業会社予算報告",
                    topicCategory: 'A',
                    timeinMins: 120
                },
                {
                    topicText: "予算承認",
                    topicCategory: 'A',
                    timeinMins: 30
                },

                ],
                note: "主要事業会社取締役会で承認",
            },

            {
                agendaId: 11,
                agendaTitle: "取締役会議長の選任",
                category: { order: 6, name: "Others", color: "#5D6D7E" },
                meetingType: { label: "取締役会", color: "#F5CBA7" },
                priority: "Low",
                frequency: "Annually",
                resolutionType: "In Person",
                topics: [{
                    topicText: "決議（トータル10）",
                    topicCategory: 'A',
                    timeinMins: 10

                },

                ],
                note: "",
            },


            {
                agendaId: 8,
                agendaTitle: "委員長の選任",
                category: { order: 3, name: "HR", color: "#F5B041" },
                meetingType: { label: "監査等委員会／監査役会", color: "#A2D9CE" },
                priority: "Low",
                frequency: "Quarterly",
                resolutionType: "In Writing",
                topics: [{
                    topicText: "決議",
                    topicCategory: 'A',
                    timeinMins: 20
                },],
                note: "",
            },


            ];
        },
    },
}

function gettersMap() {
    return mapGetters({
        categoriesList: "tenant/agendaCategories",
        meetingTypesList: "tenant/agendaMeetingTypes",
    });
}